<template>
  <div class="dgii-rnc-importador">
    <v-btn small outlined color="primary" :disabled="!puedeActualizar" @click="abrir"
      :title="puedeActualizar ? 'Actualizar padron DGII' : 'Solo administradores'">
      <i class="fa fa-upload mr-2" aria-hidden="true"></i>Actualizar padrón DGII
    </v-btn>
    <v-dialog v-model="visible" max-width="640" :persistent="cargando" scrollable>
      <v-card>
        <v-card-title>Actualizar padrón DGII</v-card-title>
        <v-card-text>
          <div class="dgii-rnc-resumen">
            <span>Registros: <strong>{{ estado.registros }}</strong></span>
            <span>Última actualización: <strong>{{ ultimaActualizacion }}</strong></span>
          </div>
          <v-file-input v-model="archivo" accept=".txt,text/plain" label="Archivo DGII_RNC.TXT" outlined dense
            :disabled="cargando" show-size @change="cambiarArchivo" />
          <v-checkbox v-model="confirmado" :disabled="cargando" label="Confirmo la actualización del padrón compartido" dense />
          <v-progress-linear v-if="cargando" :value="progreso" :indeterminate="progreso >= 100" color="primary" />
          <div v-if="cargando" class="my-2" role="status">{{ progreso < 100 ? 'Enviando archivo: ' + progreso + '%' : 'Actualizando padrón...' }}</div>
          <v-alert v-if="mensaje" dense text :type="error ? 'error' : 'success'" class="mt-3" role="status">{{ mensaje }}</v-alert>
          <div v-if="resultado" class="dgii-rnc-resultado">
            <div>Actualizados: <strong>{{ resultado.actualizados }}</strong></div>
            <div>Omitidos: <strong>{{ resultado.omitidos }}</strong></div>
            <div>Repetidos: <strong>{{ resultado.repetidos }}</strong></div>
            <div>Filas recompuestas: <strong>{{ resultado.multilinea }}</strong></div>
          </div>
          <ul v-if="resultado && resultado.incidencias && resultado.incidencias.length" class="mt-3">
            <li v-for="(incidencia, index) in resultado.incidencias" :key="index">{{ incidencia }}</li>
          </ul>
        </v-card-text>
        <v-card-actions class="dgii-rnc-acciones">
          <v-btn text :disabled="cargando" @click="visible = false">Cerrar</v-btn>
          <v-btn text :disabled="cargando" @click="cargarEstado" title="Consultar estado del padron"><i class="fa fa-refresh mr-2" aria-hidden="true"></i>Consultar estado</v-btn>
          <v-btn color="primary" :loading="cargando" :disabled="!archivo || !confirmado || !puedeActualizar || cargando" @click="actualizar">
            <i class="fa fa-upload mr-2" aria-hidden="true"></i>Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return { visible: false, puedeActualizar: false, archivo: null, confirmado: false, cargando: false,
      progreso: 0, estado: { registros: 0, ultima_actualizacion: null }, mensaje: "", error: false, resultado: null };
  },
  computed: {
    ultimaActualizacion() {
      return this.estado.ultima_actualizacion ? new Date(this.estado.ultima_actualizacion).toLocaleString("es-DO") : "Sin carga";
    },
  },
  mounted() {
    this.$axios.get(this.url("permisos"), { headers: this.headers() })
      .then(res => { this.puedeActualizar = res.data.puedeActualizar === true; }).catch(() => { this.puedeActualizar = false; });
  },
  methods: {
    url(accion) { return this.$hostname + this.$hName + "/padron-dgii/" + accion; },
    headers() { return this.$store.getters.GetheadersAxios || {}; },
    abrir() {
      if (!this.puedeActualizar) return;
      this.visible = true;
      return this.cargarEstado();
    },
    cargarEstado() {
      return this.$axios.get(this.url("estado"), { headers: this.headers(), timeout: 15000 })
        .then(res => { this.estado = res.data; })
        .catch(() => { this.error = true; this.mensaje = "No se pudo consultar el estado del padron DGII."; });
    },
    cambiarArchivo() { this.confirmado = false; this.mensaje = ""; this.resultado = null; },
    async actualizar() {
      if (this.cargando || !this.puedeActualizar || !this.confirmado) return;
      if (!this.archivo || !/\.txt$/i.test(this.archivo.name) || !this.archivo.size || this.archivo.size > 128 * 1024 * 1024) {
        this.error = true; this.mensaje = "Seleccione un archivo TXT DGII de hasta 128 MB."; return;
      }
      this.cargando = true; this.progreso = 0; this.mensaje = ""; this.resultado = null; this.error = false;
      var form = new FormData(); form.append("file", this.archivo);
      try {
        var res = await this.$axios.post(this.url("importar"), form, {
          headers: Object.assign({}, this.headers(), { "Content-Type": "multipart/form-data" }), timeout: 900000,
          onUploadProgress: event => { if (event.total) this.progreso = Math.round(event.loaded * 100 / event.total); },
        });
        this.resultado = res.data; this.mensaje = "Padron DGII actualizado.";
        this.archivo = null; this.confirmado = false;
        await this.cargarEstado();
      } catch (error) {
        this.error = true;
        var respuesta = error && error.response;
        this.mensaje = respuesta && respuesta.status === 413 ? "El servidor no admite este tamano de archivo. Revise el limite de carga."
          : respuesta && [400, 403, 409].indexOf(respuesta.status) >= 0 && typeof respuesta.data === "string" ? respuesta.data
          : "No se pudo confirmar la actualizacion. Consulte el estado del padron antes de volver a cargar el archivo.";
      } finally { this.cargando = false; }
    },
  },
};
</script>

<style scoped>
.dgii-rnc-importador { display: flex; justify-content: flex-end; align-items: center; min-height: 40px; }
.dgii-rnc-resumen { display: flex; flex-wrap: wrap; gap: 8px 20px; margin-bottom: 20px; }
.dgii-rnc-resultado { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
.dgii-rnc-acciones { flex-wrap: wrap; justify-content: flex-end; gap: 4px; }
@media (max-width: 600px) {
  .dgii-rnc-importador { justify-content: flex-start; }
  .dgii-rnc-acciones .v-btn { margin-left: 0 !important; }
}
</style>
